<template>

  <div class="app-container pull-auto">
    <!--功能按钮组件页面-->
    <el-row :gutter="20">
      <div style="height: auto;">
        <el-form :inline="true" class="demo-form-inline">
          <el-form-item label="项目信息">
            <el-input v-model="form.condition" placeholder="项目名称/项目地址" clearable></el-input>
          </el-form-item>
          <el-form-item label="项目时间" class="searchdata">
            <el-date-picker v-model="form.time" type="daterange" align="right" unlink-panels range-separator="至"
              start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" :picker-options="pickerOptions"
              style="width:160px;">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="项目状态">
            <el-select v-model="form.state" placeholder="请选择" clearable style="width:80%;">
              <el-option v-for="item in state" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button @click="seacrhdata" type="primary">搜索</el-button>
            <a @click="importexcel" download="模板文件" style="margin-left: 20px;">导出</a>
          </el-form-item>
        </el-form>
      </div>
    </el-row>
    <el-row>
      <el-col :span="4">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="月份" name="first" >
            <avue-crud :data="monthdata" :option="monthoption" @refresh-change="getList" @current-row-change="handleCurrentRowChange"
              @row-click="handleRowClick" class="pointer">
              <template slot-scope="scope" slot="feedbackCount">
                <i class="el-icon-arrow-right"></i>
              </template>
            </avue-crud>
          </el-tab-pane>
          <el-tab-pane label="项目" name="second">
            <avue-crud :data="monthyear" :option="yearoption" @refresh-change="getList1" @current-row-change="handleCurrentRowChange"
              @row-click="handleRowClick" class="pointer">
              <template slot-scope="scope" slot="feedbackCount">
                <i class="el-icon-arrow-right"></i>
              </template>
            </avue-crud>
          </el-tab-pane>
        </el-tabs>
      </el-col>
      <el-col :span="20">
        <el-tabs v-model="activeName1" @tab-click="handleClick" class="tabfloat">
          <el-tab-pane label="全部" name="first">
            <avue-crud :data="tableData" :option="tableOption" @refresh-change="getallfeedback" @row-click="showRow">
              <template slot-scope="scope" slot="menu">
                <el-button icon="el-icon-check" size="small">详情</el-button>
              </template>
            </avue-crud>
          </el-tab-pane>
          <el-tab-pane label="解决" name="second1">
            <avue-crud :data="tableData" :option="tableOption" @row-click="showRow">
              <template slot-scope="scope" slot="menu">
                <el-button icon="el-icon-check" size="small">详情</el-button>
              </template>
            </avue-crud>
          </el-tab-pane>
          <el-tab-pane label="未解决" name="third">
            <avue-crud :data="tableData" :option="tableOption" @row-click="showRow">
              <template slot-scope="scope" slot="menu">
                <el-button icon="el-icon-check" size="small">详情</el-button>
              </template>
            </avue-crud>
          </el-tab-pane>
        </el-tabs>
      </el-col>
    </el-row>
    <!--查看评论信息-->
    <comment2 ref="childcomment"></comment2>
  </div>
</template>

<script>
  import {
    Feedbackmonth,
    FeedbackOneYear,
    allfeedback,
    impotdata
  } from '@/api/admin/taskManagement'
  import {
    mapGetters
  } from 'vuex'
  import {
    objKeySort
  } from '@/util/ajaxsign'
  import {
    dealElement
  } from '@/util/util'
  import comment2 from "../orderManager/comment2.vue";
  import {
    apiLink
  } from '@/config/env'
  import {
    debuglog
  } from 'util';
  import '../../styles/btn.scss';

  export default {
    name: 'manufacturerinfo',
    components: {
      comment2
    },
    data() {
      return {
        activeName: 'first',
        activeName1: 'first',
        hrefurl: '',
        monthdata: [],
        monthyear: [],
        searchdata: {},
        list: [],
        total: 0,
        listQuery: {
          current: 1,
          size: 10,
          total: 0,
        },
        // 搜索
        form: {
          time: '',
          state: '',
          condition: ''
        },
        state: [{
            label: "未发布",
            value: "-1"
          },
          {
            label: "正在招募",
            value: "0"
          },
          {
            label: "等待执行",
            value: "1"
          },
          {
            label: "用户取消",
            value: "2"
          },
          // { label : "项目超时", value : "3" },
          {
            label: "正在执行",
            value: "4"
          },
          {
            label: "申请结项",
            value: "5"
          },
          {
            label: "拒绝结项",
            value: "6"
          },
          {
            label: "项目完结",
            value: "7"
          }
        ],
        stopFalse: {},
        dialogStop: false,
        dialogStart: false,
        radio: '',
        // 企业按钮开关
        companyTon: false,
        // 企业状态
        cSate: '',
        // 弹框开关
        //按钮禁用开关
        totalStatus: true,
        deleteStatus: true,
        cancelStateus: true,
        agreestate: true,
        againStatus: true,
        inviteStatus: true,
        add: false,
        fkStatus: true,
        // 状态
        companyId: '',
        tableData: [],
        page: {
          pageSizes: [10, 20, 50, 100],
          currentPage: 1,
          total: 0,
          pageSize: 10
        },
        tableLoading: false,
        yearoption: {
          addBtn: false,
          highlightCurrentRow: true,
          refreshBtn: false,
          columnBtn: false,
          editBtn: false,
          delBtn: false,
          menu: false,
          page: false,
          border: false,
          searchBtn: false,
          header: false,
          headerMenu: false,
          align: 'center',
          menuAlign: 'center',
          height: window.innerHeight - 290,
          serviceType: '',
          index: false,
          column: [{
            label: '项目名称',
            overHidden: true,
            prop: 'projectName'
          }, {
            label: '反馈总数',
            prop: 'feedbackCount'
          }, {
            label: '',
            prop: 'feedbackCount',
            width: 40,
            solt: true
          }]
        },
        monthoption: {
          addBtn: false,
          highlightCurrentRow: true,
          refreshBtn: false,
          columnBtn: false,
          editBtn: false,
          delBtn: false,
          menu: false,
          page: false,
          border: false,
          searchBtn: false,
          header: false,
          headerMenu: false,
          align: 'center',
          menuAlign: 'center',
          height: window.innerHeight - 290,
          serviceType: '',
          index: false,
          column: [{
            label: '月份',
            prop: 'month'
          }, {
            label: '反馈总数',
            prop: 'feedbackCount'
          }, {
            label: '',
            prop: 'feedbackCount',
            width: 40,
            solt: true
          }]
        },
        tableOption: {
          addBtn: false,
          refreshBtn: false,
          columnBtn: true,
          editBtn: true,
          delBtn: true,
          menu: false,
          page: true,
          border: true,
          header: false,
          headerMenu: false,
          align: 'center',
          menuAlign: 'center',
          height: window.innerHeight - 290,
          serviceType: '',
          index: false,
          column: [{
            label: '问题状态',
            prop: 'flag',
            formatter: function(row, value, label, column) {
              return row.flag == 1 ? '已解决' : '未解决';
            }
          }, {
            label: '问题描述',
            prop: 'tips',
            overHidden: true,
            formatter: function(row, value, label, column) {
              return row.tips.split("times")[0];
            }
          }, {
            label: '项目名称',
            prop: 'projectName'
          }, {
            label: '问题发布人',
            prop: 'userName'
          }, {
            label: '反馈发布时间',
            prop: 'startTime',
            overHidden: true,
            type: 'date',
            format: 'yyyy-MM-dd HH:mm:ss',
            valueFormat: 'yyyy-MM-dd HH:mm:ss'
          }, {
            label: '查看(次)',
            prop: 'viewNum'
          }, {
            label: '评论(次)',
            prop: 'commentNum'
          }, {
            label: '项目状态',
            prop: 'projectState',
            overHidden: true,
            formatter: function(row, value, label, column) {
              if (Number(value) === -2) {
                return '用户取消'
              } else if (Number(value) === -1) {
                return '未发布'
              } else if (Number(value) === 0) {
                return '正在招募'
              } else if (Number(value) === 1) {
                return '等待执行'
              } else if (Number(value) === 2) {
                return '用户取消'
              } else if (Number(value) === 4) {
                return '正在执行'
              } else if (Number(value) === 5) {
                return '申请结项'
              } else if (Number(value) === 6) {
                return '拒绝结项'
              } else if (Number(value) === 7) {
                return '项目完结'
              }
            }

          }]
        },
        pickerOptions: {
          shortcuts: [{
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }]
        },
      }
    },
    created() {
      this.getList1();
      this.getList();
    },
    mounted: function() {},
    computed: {
      ...mapGetters(['permissions'])
    },
    methods: {
      //查询数据
      seacrhdata() {
        this.tableData = [];
        this.getList1();
        this.getList();
      },

      refreshChangemonth() {
        this.getList();
      },

      showRow(row) {
        console.log(row)
        this.$refs.childcomment.commentstate(row.id, 2);
      },

      getList() {
        Feedbackmonth(objKeySort(dealElement({
          startDate: this.form.time[0] ? this.form.time[0] + ' 00:00:00' : null,
          stopDate: this.form.time[1] ? this.form.time[1] + ' 23:59:59' : null,
          state: this.form.state,
          condition: this.form.condition
        }))).then(response => {
          this.monthdata = response.data.data
          this.searchdata = {
            month: response.data.data[0].month
          }
          this.getallfeedback()
        })
      },
      getList1() {
        FeedbackOneYear(objKeySort(dealElement({
          startDate: this.form.time[0] ? this.form.time[0] + ' 00:00:00' : null,
          stopDate: this.form.time[1] ? this.form.time[1] + ' 23:59:59' : null,
          state: this.form.state,
          condition: this.form.condition
        }))).then(response => {
          this.monthyear = response.data.data
          this.searchdata = {
            projectId: response.data.data[0].projectId
          }
          this.getallfeedback()
        })
      },
      sizeChange(val) {
        this.listQuery.size = val;
        this.page.pageSize = val;
        this.listQuery.current = 1;
        this.getList()
      },
      currentChange(val) {
        this.listQuery.current = val;
        this.page.currentPage = val;
        this.getList()
      },
      handleCurrentRowChange(val) {
       console.log(val)


      },

      importexcel() {
        let parm = '';
        let p = objKeySort(this.searchdata);
        Object.keys(p).forEach(key => {
          parm = parm + key + '=' + p[key] + '&';
        })
        parm = parm.substring(0, parm.length - 1);
        window.location.href = apiLink('/projectExecution/importProjectFeedbacks') + "?" + parm;
      },

      refreshChangepro() {
        this.getallfeedback()
      },

      //获取反馈数据信息
      getallfeedback() {
        allfeedback(objKeySort(dealElement(this.searchdata))).then(response => {
          this.tableData = response.data.data
        })
      },
      //查询反馈数据
      handleRowClick(row, event, column) {
        if (row.month) {
          this.searchdata = {
            month: row.month
          }
          this.getallfeedback()
        } else {
          this.searchdata = {
            projectId: row.projectId
          }
          this.getallfeedback()
        }
      },

      //查询状态
      handleClick(tab, event) {
        if (tab.name == 'second1') {
          this.searchdata.flag = 1;
          this.getallfeedback()
        } else if (tab.name == 'third') {
          this.searchdata.flag = 0;
          this.getallfeedback()
        } else if(tab.name=='first'){
          this.getList()
        }else if(tab.name=='second'){
          this.getList1()
        }
        else {
          this.searchdata.flag = undefined;
          this.getallfeedback()
        }
      },
      /**
       * 刷新回调
       */
      refreshChangeyear() {
        this.getList1()
      },
    }
  }
</script>

<style lang="scss" scoped>
  .el-table {
    margin-top: 22px;
  }

  .el_s_left {
    float: left
  }

  .el_btn {
    clear: both;
  }

  .filter-item1 {
    width: auto;
    height: 40px;
    line-height: 40px;
    padding: 0 15px;
    border: 0 !important;
    margin-left: 0 !important;
    margin-right: 22px;
  }

  .el-radio__label {
    display: none;
  }

  .sh_tip {
    vertical-align: top;
    display: inline-block
  }

  .lf_item span:first-child {
    display: inline-block;
    width: 100px;
    vertical-align: top;
  }

  .el-form-items {
    float: left;
    width: 48% !important;
  }

  .el-form-itemss {
    width: 300px !important;
    height: 40px !important;
    background-attachment: #fff !important;
  }

  .el-form-itemss .el-input {
    outline: none !important;
  }

  .el-f-item {
    width: 100% !important;
  }

  .el-dialog__header {
    margin-bottom: 0px;
  }

  .el-tag {
    border: 0 !important;
    color: #666 !important;
    background-color: transparent;
    font-size: 14px;
  }

  .dialog-footer {
    margin-left: 0 !important;
  }

  .filter-item1 {
    width: auto;
    height: 40px;
    line-height: 40px;
    padding: 0 15px;
    border: 0 !important;
    margin-left: 0 !important;
    margin-right: 22px;
  }

  .is-required {}

  .el-dialog__footer {
    -height: 120px;
  }

  .p1 {
    width: 100% !important;
  }

  .part {
    position: relative;
  }

  .el-table ::v-deep .el-table__row:nth-child(even) {
    background-color: #F6F9FF !important;
  }

  .seach {
    width: 70%;
    float: left;
  }

  .promoth {
    margin-top: 15px;
    background: #fafafa;
    text-align: center;
  }

  .daochu {
    float: right;
    margin-right: 20px;
  }

  .tabfloat ::v-deep .el-tabs__nav {
    float: right !important;
  }

  .pointer {
    cursor: pointer;
  }

  .searchdata ::v-deep .el-form-item__content {
    width: 252px;
  }

  .app-container ::v-deep .el-table__body {
    font-weight: 400;
  }

  .left ::v-deep .el-table__empty-block {
    width: 100% !important;
  }
</style>
